import React, { Component } from 'react'
import { graphql, StaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Sprite from '~components/Sprite'
import Arrow from '~components/Arrow'
import Social from '~components/Social'
import Dropdown from '~components/Dropdown'
import * as styles from '~styles/layout/footer.module.scss'
import Link from '~components/Link'
import * as arrowStyles from '~styles/components/arrow.module.scss'
import { StaticImage } from 'gatsby-plugin-image'

export default class Footer extends Component {
  scroll (e) {
    e.preventDefault()

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  getYear () {
    const date = new Date()
    return date.getFullYear()
  }

  getParentSlug (item) {
    const parent = item.page.contentfulparent
    return parent ? `${parent.slug}/` : ''
  }

  render () {
    return (
      <StaticQuery
        query={query}
        render={({ contentfulMenu, subMenu }) => (
          <footer className={styles.footer} role="contentinfo">
            <div className={classNames('grid-container')}>
              <div className={styles.inner}>
                <div className="grid-x grid-margin-x">
                  <div className="cell large-2">
                    <a
                      href="/"
                      className={styles.logo}
                      aria-label="London City Aiport"
                    >
                      <Sprite name="logoSmall" />
                    </a>
                  </div>

                  <div className="cell large-9 xlarge-8 large-offset-1 xlarge-offset-2">
                    <nav className="grid-x grid-margin-x">
                      {contentfulMenu.items && (
                        <div
                          className={classNames(
                            styles.navItem,
                            styles.row,
                            'cell large-auto xlarge-3'
                          )}
                        >
                          <h4
                            className={classNames(
                              styles.navTitle,
                              'show-for-large'
                            )}
                          >
                            {contentfulMenu.title}
                          </h4>

                          <ul
                            className={classNames(
                              styles.menu,
                              'show-for-large'
                            )}
                          >
                            {contentfulMenu.items.map((item, index) => {
                              const parentSlug = this.getParentSlug(item)

                              return (
                                <li className={styles.menuItem} key={index}>
                                  <Link
                                    href={`/${parentSlug}${item.page.slug}`}
                                    className={styles.menuLink}
                                  >
                                    {item.title}
                                  </Link>
                                </li>
                              )
                            })}
                          </ul>

                          <div
                            className={classNames(
                              styles.dropdown,
                              'hide-for-large'
                            )}
                          >
                            <Dropdown
                              title={contentfulMenu.title}
                              links={contentfulMenu.items}
                            />
                          </div>
                        </div>
                      )}

                      <div
                        className={classNames(
                          styles.navItem,
                          styles.row,
                          'cell large-auto xlarge-3'
                        )}
                      >
                        <h4
                          className={classNames(
                            styles.navTitle,
                            'show-for-large'
                          )}
                        >
                          Get in touch
                        </h4>

                        <address
                          className={classNames(
                            styles.address,
                            'show-for-large'
                          )}
                        >
                          London City Airport
                          <br />
                          Royal Docks
                          <br />
                          London
                          <br />
                          E16 2PB
                        </address>

                        <div
                          className={classNames(
                            styles.dropdown,
                            'hide-for-large'
                          )}
                        >
                          <Dropdown
                            title="Get in touch"
                            content="London City Airport<br /> Royal Docks<br /> London<br /> E16 2PB"
                          />
                        </div>
                      </div>

                      <div
                        className={classNames(
                          styles.navItem,
                          'cell large-auto xlarge-4'
                        )}
                      >
                        <h4
                          className={classNames(
                            styles.navTitle,
                            'show-for-large'
                          )}
                        >
                          Follow us
                        </h4>

                        <ul
                          className={classNames(styles.menu, 'show-for-large')}
                        >
                          <li className={styles.menuItem}>
                            <Link
                              href="https://x.com/lcymediasales"
                              text="X"
                              className={styles.menuLink}
                              track={{
                                category: 'X',
                                action: 'Follow',
                                label: 'https://x.com/lcymediasales'
                              }}
                            />
                          </li>
                          <li className={styles.menuItem}>
                            <Link
                              href="https://www.linkedin.com/in/london-city-airport-media-sales-568a8017a/"
                              text="LinkedIn"
                              className={styles.menuLink}
                              track={{
                                category: 'LinkedIn',
                                action: 'Follow',
                                label:
                                  'https://www.linkedin.com/company/lcymediasales'
                              }}
                            />
                          </li>
                        </ul>
                      </div>
                      <div
                        className={classNames('cell large-auto xlarge-2', styles.servatorLogoWrapper)}
                      >
                        <StaticImage
                          src="../../assets/images/servator-logo.png"
                          alt="Project Servator"
                          placeholder="blurred"
                          width={130}
                        />
                      </div>
                    </nav>
                  </div>

                  <div
                    className={classNames(styles.row, 'cell', 'hide-for-large')}
                  >
                    <Social />
                  </div>

                  <div className={classNames('cell', styles.footnote)}>
                    <p
                      className={classNames(styles.copyright, 'show-for-large')}
                    >
                      &copy;
                      {' '}
                      {`${this.getYear()} London City Airport. All Rights Reserved.`}
                    </p>

                    {subMenu.items && (
                      <ul className={styles.subMenu}>
                        {subMenu.items.map((item, index) => {
                          const parentSlug = this.getParentSlug(item)

                          return (
                            <li className={styles.subMenuItem} key={index}>
                              <Link
                                href={`/${parentSlug}${item.page.slug}`}
                                className={styles.subMenuLink}
                              >
                                {item.title}
                              </Link>
                            </li>
                          )
                        })}

                        <li className={styles.subMenuItem}>
                          <Link
                            href="https://www.londoncityairport.com/privacy-policy"
                            className={styles.subMenuLink}
                          >
                            Privacy policy
                          </Link>
                        </li>

                        <li className={styles.subMenuItem}>
                          <Link
                            href="https://www.londoncityairport.com/accessibility-statement-media-sales"
                            className={styles.subMenuLink}
                          >
                            Accessibility
                          </Link>
                        </li>
                      </ul>
                    )}
                  </div>

                  <Arrow
                    className={classNames(
                      styles.arrow,
                      arrowStyles.blue,
                      arrowStyles.up
                    )}
                  />
                  <div className="cell hide-for-large">
                    <p className={styles.copyright}>
                      &copy;
                      {' '}
                      {`${this.getYear()} London City Airport. All Rights Reserved.`}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )}
      />
    )
  }
}

Footer.propTypes = {
  data: PropTypes.object
}

export const query = graphql`
  query {
    contentfulMenu(name: { eq: "footer-menu" }) {
      id
      title
      items {
        id
        title
        page {
          slug
          contentfulparent {
            slug
          }
        }
      }
    }
    subMenu: contentfulMenu(name: { eq: "sub-menu" }) {
      id
      title
      items {
        id
        title
        page {
          slug
          contentfulparent {
            slug
          }
        }
      }
    }
  }
`
